import { SelectUserRole } from '~/modules/settings/components/SelectUserRole';
import { SelectLabelGroups } from '~settings/components/SelectLabelGroups';

interface InternalPermissionsProps {
  name: string;
}

export function InternalPermissions({ name }: InternalPermissionsProps) {
  return (
    <div className="grid grid-cols-3 items-start gap-md">
      <SelectUserRole
        multiselect
        name={`${name}.roles`}
        targetUserType="INTERNAL"
      />
      <SelectLabelGroups name={`${name}.labelGroups`} />
    </div>
  );
}

InternalPermissions.displayName = 'InternalPermissions';
